/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {Operation} from '@ion/core/src/types/general';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';

/**
 * Provides a utility hook to check the current user role has any one
 * of FILE PERMISSIONS feature enabled CREATE/UPDATE/READ/ASSIGN.
 *
 * ```typescript
 *
 * import {useFilePermissionsSearchFilter} from '@ion/applications/src/hooks/';
 *
 * const filePermissionsIds = useFilePermissionsSearchFilter();
 *
 * ```
 *
 */
export const useFilePermissionsSearchFilter = (Features: GenericObject) => {
  const extendedAttribute   = Features?._userRoles[0]?.extendedAttribute;
  const currentUserFeatures = extendedAttribute ? safeJSONParse(extendedAttribute?.value) : [];
  const filePermissions     = currentUserFeatures?.features?.find(
    (item) => item?.id === Features?.checkFilePermissionId('FILE_PERMISSIONS'))?.features || [];
  return filePermissions?.filter(
    item => item?.modules?.some(
      data => data?.name?.toLowerCase() !== Operation.Delete && data?.enabled
    ))?.map(item => item?.modules?.[0]?.id?.split?.('-')?.[0]);
};

export default useFilePermissionsSearchFilter;
